import { render, staticRenderFns } from "./BrightnessSensor.vue?vue&type=template&id=54a95976&scoped=true&"
import script from "./BrightnessSensor.vue?vue&type=script&lang=ts&"
export * from "./BrightnessSensor.vue?vue&type=script&lang=ts&"
import style0 from "./BrightnessSensor.vue?vue&type=style&index=0&id=54a95976&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a95976",
  null
  
)

export default component.exports